/****************************************************************************************************
 * 設定
 ****************************************************************************************************/
var isDev = false;
// 本番用ベースディレクトリ
var baseProdDir = "/";
// テストアップ用ベースディレクトリ
var baseDevDir = "/testup/2018/hoge/www/";
export default {
    baseDir: isDev ? baseDevDir : baseProdDir,
    breakPointMD: 737,
    breakPointLG: 1024,
    supportAndroid: 5,
    supportIOS: 10,
    supportIE: 11,
    useLoading: false,
};
